/* Toner-Kontor – Theme-JavaScript
   Kein Framework, keine externen Abhängigkeiten. */
(function () {
  'use strict';

  var on = function (el, ev, fn) { if (el) el.addEventListener(ev, fn); };
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------------- Mobile-Menü ---------------- */
  function initDrawer() {
    var drawer = $('[data-drawer]');
    if (!drawer) return;
    var panel = $('.mobile-drawer__panel', drawer);
    var lastFocus = null;

    function open(trigger) {
      lastFocus = trigger || document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var first = panel.querySelector('button, a, input');
      if (first) first.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }

    $$('[data-drawer-open]').forEach(function (b) { on(b, 'click', function () { open(b); }); });
    $$('[data-drawer-close]').forEach(function (b) { on(b, 'click', close); });
    on(drawer, 'click', function (e) { if (e.target === drawer) close(); });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
      if (e.key === 'Tab' && drawer.classList.contains('is-open')) {
        var f = $$('a[href], button:not([disabled]), input, select, [tabindex]:not([tabindex="-1"])', panel)
          .filter(function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* ---------------- Toner-Finder ---------------- */
  function initFinder() {
    $$('[data-finder]').forEach(function (root) {
      var dataEl = $('[data-finder-data]', root) || $('#tk-printer-data');
      if (!dataEl) return;
      var printers = [];
      try { printers = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var brandBtns = $$('[data-finder-brand]', root);
      var select = $('[data-finder-model]', root);
      var go = $('[data-finder-go]', root);
      var count = $('[data-finder-count]', root);
      var chosen = null;

      function fillModels(brand) {
        select.innerHTML = '';
        var placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = brand ? 'Bitte Modell wählen …' : 'Zuerst Hersteller wählen';
        select.appendChild(placeholder);
        if (!brand) { select.disabled = true; return; }

        var list = printers.filter(function (p) { return p.b === brand; });
        var groups = {};
        list.forEach(function (p) { (groups[p.s] = groups[p.s] || []).push(p); });
        Object.keys(groups).sort().forEach(function (g) {
          var og = document.createElement('optgroup');
          og.label = g;
          groups[g].sort(function (a, b) { return a.m.localeCompare(b.m); }).forEach(function (p) {
            var o = document.createElement('option');
            o.value = p.h;
            o.textContent = p.m;
            og.appendChild(o);
          });
          select.appendChild(og);
        });
        select.disabled = false;
        if (count) count.textContent = list.length + ' Modelle';
      }

      brandBtns.forEach(function (btn) {
        on(btn, 'click', function () {
          brandBtns.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          chosen = btn.getAttribute('data-finder-brand');
          fillModels(chosen);
          select.focus();
          if (go) go.disabled = true;
        });
      });

      on(select, 'change', function () { if (go) go.disabled = !select.value; });
      on(go, 'click', function () { if (select.value) window.location.href = '/collections/' + select.value; });
      fillModels(null);
      if (go) go.disabled = true;

      /* Tabs */
      var tabs = $$('[data-finder-tab]', root);
      tabs.forEach(function (tab) {
        on(tab, 'click', function () {
          tabs.forEach(function (t) {
            t.setAttribute('aria-selected', String(t === tab));
            var p = document.getElementById(t.getAttribute('aria-controls'));
            if (p) p.hidden = (t !== tab);
          });
        });
      });
    });
  }

  /* ---------------- Kompatibilitätsliste aufklappen ---------------- */
  function initCompat() {
    $$('[data-compat-more]').forEach(function (btn) {
      on(btn, 'click', function () {
        var box = btn.closest('.compat');
        var hidden = $$('.is-hidden', box);
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          $$('li[data-extra]', box).forEach(function (li) { li.classList.add('is-hidden'); });
          btn.setAttribute('aria-expanded', 'false');
          btn.textContent = btn.getAttribute('data-label-more');
          box.scrollIntoView({ block: 'nearest' });
        } else {
          hidden.forEach(function (li) { li.classList.remove('is-hidden'); });
          btn.setAttribute('aria-expanded', 'true');
          btn.textContent = btn.getAttribute('data-label-less');
        }
      });
    });
  }

  /* ---------------- Mengen-Stepper ---------------- */
  function initQty() {
    $$('[data-qty]').forEach(function (box) {
      var input = $('input', box);
      $$('button', box).forEach(function (btn) {
        on(btn, 'click', function () {
          var step = btn.getAttribute('data-qty-step') === 'up' ? 1 : -1;
          var val = parseInt(input.value, 10) || 1;
          var min = parseInt(input.getAttribute('min'), 10) || 1;
          input.value = Math.max(min, val + step);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------------- Versand-Countdown ---------------- */
  function berlinNow() {
    var s = new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' });
    return new Date(s);
  }

  function initCountdown() {
    var els = $$('[data-countdown]');
    if (!els.length) return;

    function tick() {
      var now = berlinNow();
      var cutoff = parseInt(els[0].getAttribute('data-countdown'), 10) || 14;
      var day = now.getDay(); // 0 = So
      var minutesLeft = (cutoff * 60) - (now.getHours() * 60 + now.getMinutes());
      els.forEach(function (el) {
        var soon = el.querySelector('[data-countdown-text]');
        if (!soon) return;
        if (day >= 1 && day <= 5 && minutesLeft > 0) {
          var h = Math.floor(minutesLeft / 60);
          var m = minutesLeft % 60;
          var t = h > 0 ? h + ' Std. ' + m + ' Min.' : m + ' Min.';
          soon.innerHTML = 'Noch <strong>' + t + '</strong> bestellen &ndash; dann geht Ihr Paket heute raus.';
        } else if (day === 6 || day === 0) {
          soon.textContent = 'Bestellungen vom Wochenende versenden wir am Montag.';
        } else {
          soon.textContent = 'Bestellungen ab jetzt versenden wir am nächsten Werktag.';
        }
      });
    }
    tick();
    setInterval(tick, 30000);
  }

  /* ---------------- Galerie ---------------- */
  function initGallery() {
    var stage = $('[data-gallery-stage]');
    if (!stage) return;
    $$('[data-gallery-thumb]').forEach(function (thumb) {
      on(thumb, 'click', function () {
        var src = thumb.getAttribute('data-src');
        var alt = thumb.getAttribute('data-alt') || '';
        var img = $('img', stage);
        if (img && src) { img.src = src; img.srcset = ''; img.alt = alt; }
        $$('[data-gallery-thumb]').forEach(function (t) { t.setAttribute('aria-current', String(t === thumb)); });
      });
    });
  }

  /* ---------------- Sticky Kaufleiste (mobil) ---------------- */
  function initStickyBuy() {
    var bar = $('[data-sticky-buy]');
    var anchor = $('[data-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('is-visible', !e.isIntersecting); });
    }, { rootMargin: '0px 0px -60px 0px' });
    io.observe(anchor);
  }

  /* ---------------- Filter & Sortierung ---------------- */
  function initCollection() {
    var sort = $('[data-sort]');
    on(sort, 'change', function () { if (sort.form) sort.form.submit(); });

    $$('[data-facet-form] input[type="checkbox"]').forEach(function (cb) {
      on(cb, 'change', function () { cb.form.submit(); });
    });

    var toggle = $('[data-facet-toggle]');
    on(toggle, 'click', function () {
      var facets = $('[data-facets]');
      if (!facets) return;
      var open = facets.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  /* ---------------- Warenkorb ---------------- */
  function initCart() {
    $$('[data-cart-qty]').forEach(function (input) {
      on(input, 'change', function () { if (input.form) input.form.submit(); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initDrawer();
    initFinder();
    initCompat();
    initQty();
    initCountdown();
    initGallery();
    initStickyBuy();
    initCollection();
    initCart();
  });
})();
